import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import Header from './Header';
import { withAreaGetter } from 'providers/AreasConsumers';
import ReportVerificationListBrowser from './ReportVerificationListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_VERIFICATION_REPORTS } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_VERIFICATION_REPORTS}>
        <ReportVerificationListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
